import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/lib/seo";

const SECTIONS = [
  {
    h: "1. About this policy",
    p: "This Privacy Policy explains how RIFIC (\"we\", \"us\") collects, uses and protects information you share through rific.in. [Effective date to be updated by RIFIC.]",
  },
  {
    h: "2. Information we collect",
    p: "When you submit a franchise enquiry or contact form, we collect the details you provide: your name, mobile number, email address, city, state, preferred location, available shop area, investment range, business experience and message. We may also collect basic technical information such as browser type and pages visited.",
  },
  {
    h: "3. How we use your information",
    p: "We use the information you share to contact you about franchise opportunities or your enquiry, to improve our website, and to communicate updates about RIFIC. We do not sell your personal information.",
  },
  {
    h: "4. Franchise enquiries",
    p: "Submitting a franchise enquiry is not an offer or agreement. Submitting your details means you agree to be contacted by RIFIC regarding franchise opportunities. Details shared about store formats, investments and returns are provided only through official RIFIC conversations.",
  },
  {
    h: "5. Data sharing",
    p: "We may share your information with trusted service providers who help us operate this website and respond to enquiries, and where required by law.",
  },
  {
    h: "6. Your choices",
    p: "You may ask us to update or delete the information you have shared by writing to rific.india@gmail.com.",
  },
  {
    h: "7. Contact",
    p: "For any privacy questions, write to rific.india@gmail.com.",
  },
];

export default function Privacy() {
  useSeo({
    title: "Privacy Policy | RIFIC",
    description: "How RIFIC collects, uses and protects the information you share through rific.in.",
    path: "/privacy",
  });

  return (
    <div data-testid="privacy-page">
      <PageHeader eyebrow="Legal" title={["PRIVACY", "POLICY."]} />
      <section className="bg-cream pb-16 md:pb-24">
        <div className="mx-auto max-w-3xl px-5 md:px-10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.h} delay={Math.min(i, 4) * 0.05}>
              <div className="border-t border-cream-line py-8">
                <h2 className="font-display text-xl font-semibold tracking-tight text-deep md:text-2xl">{s.h}</h2>
                <p className="mt-3 font-body text-base leading-relaxed text-deep/70">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
